import { render, staticRenderFns } from "./MenedgerStats.vue?vue&type=template&id=8f6e8d5e&scoped=true&"
import script from "./MenedgerStats.vue?vue&type=script&lang=js&"
export * from "./MenedgerStats.vue?vue&type=script&lang=js&"
import style0 from "./MenedgerStats.vue?vue&type=style&index=0&id=8f6e8d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6e8d5e",
  null
  
)

export default component.exports